import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotifierService } from 'angular-notifier';
import { TranslateOrgSpecificPipe } from 'src/app/common/pipes/translate-org-specific.pipe';
import { OrgService } from 'src/app/organization/org.service';
import { AdminService } from 'src/app/user/admin.service';
import { UserService } from 'src/app/user/user.service';
import { ReferralService } from '../referral.service';

@Component({
  selector: 'app-assign-referral',
  templateUrl: './assign-referral.component.html',
  styleUrls: ['./assign-referral.component.css']
})
export class AssignReferralComponent implements OnInit {

  @Input() public data;
  clinicId = 0;
  clinicians: number[];
  clinicList: any[] = [];
  clinicianList: any[] = [];

  constructor(private adminService: AdminService,
    private orgService: OrgService,
    public activeModal: NgbActiveModal,
    private referralservice: ReferralService,
    private notifier: NotifierService,
    private orgSpecificPipe: TranslateOrgSpecificPipe,
    private userservices: UserService,

  ) { }

  ngOnInit(): void {
    this.getClinicianList();
  }



  getClinicianList() {
    this.orgService.GetAllClinicianListByOrgid().subscribe((info: any) => {
      if (info) {
        this.clinicianList = info;
      }
    });
  }

  onSubmit() {

    const assigndata = {
      clinicianId: this.clinicians, referralId: this.data.referral_id,
      clientName: this.data.firstName + ' ' + this.data.lastName,
      formName: this.data.referralType
    };
    this.referralservice.saveAssignedData(assigndata).subscribe((info: any) => {
      if (info) {
        this.notifier.notify('success', this.orgSpecificPipe.transform('AssignedSuccess'));
        this.closeModal();
      }
    });
  }

  closeModal() {
    this.activeModal.close('Modal Closed');
  }

}
